import Status from "../components/cell_types/Status.vue";
import TableSortingTypeEnum from "../../../../enums/TableSortingTypesEnum";
import PolicyPaymentTermEnum from "../../../../enums/PolicyPaymentTermEnum";
import ContractNumber from "../components/cell_types/ContractNumber.vue";
import RawHtml from "../components/cell_types/RawHtml.vue";
import InsuredAmounts from "../components/cell_types/InsuredAmounts.vue";
import DateCell from "../components/cell_types/DateCell.vue";
import Labels from "../components/cell_types/Labels.vue";
import AgencyCell from "../components/cell_types/AgencyCell.vue";

export default () => ({
  familyArray: null,
  family: null,
  activeCustomer: null,
  activeCustomerId: null,
  filterLoaded: false,
  loading: true,
  policyCount: 0,
  packageCount: 0,
  displayState: {
    packages: true,
    policies: true,
  },
  filter: {
    packages: {
      mutation_codes: {
        Vervallen: true,
        Lopend: true,
      },
    },
    policies: {
      mutation_codes: {
        Vervallen: true,
        Lopend: true,
      },
    },
  },
  policies: {},
  inactivePackages: {},
  activePackages: {},
  filterOptions: {},
  policyTableHeaders: [
    {
      key: "status",
      title: "Status",
      width: "100px",
      typeComponent: Status,
      sortAs: TableSortingTypeEnum.ALPHANUMERIC,
      getSortableValue(row, key) {
        return row[key].description;
      },
    },
    {
      key: (row) => row.name,
      title: "Polisnummer",
      width: "140px",
      typeComponent: ContractNumber,
      sortAs: TableSortingTypeEnum.NUMERIC,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: "description",
      title: "Beschrijving",
      width: "250px",
      typeComponent: RawHtml,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: "agency",
      title: "Maatschappij",
      width: "140px",
      typeComponent: AgencyCell,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: "insured_amounts",
      title: "Verz.som",
      width: "110px",
      typeComponent: InsuredAmounts,
      sortAs: TableSortingTypeEnum.ALPHANUMERIC,
      getSortableValue(row) {
        const amountsArray = Object.values(row.insured_amounts);
        return amountsArray[0];
      },
    },
    {
      key: (row) => `${row.total_term_amount} ${PolicyPaymentTermEnum[row.payment_term] || "p/m"}`,
      title: "Premie",
      width: "100px",
      sortAs: TableSortingTypeEnum.NUMERIC,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: "mutation_date",
      title: "Mutatiedatum",
      width: "130px",
      typeComponent: DateCell,
      sortAs: TableSortingTypeEnum.DATE,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: "expiration_date",
      title: "Vervaldatum",
      width: "120px",
      typeComponent: DateCell,
      sortAs: TableSortingTypeEnum.DATE,
      getSortableValue(row, key) {
        return row[key];
      },
    },
    {
      key: (row) => row?.product_labels?.data,
      title: "Labels",
      width: "100px",
      typeComponent: Labels,
    },
  ],
});
